module.exports = __webpack_public_path__ + "img/tips-personal.75e2b685.svg";